export const SearchProjectsViewOptionsStateKey = 'search-projects-view-options';

export const SearchProjectsSelectedFilterListStateKey = 'search-projects-selected-filter-list';
